import React from 'react';
import { SimpleImage } from '$partials/media';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').DoubleImageAndText}
 */

const DoubleImageAndText = ({
    heading,
    image1,
    image2,
    col1Heading,
    col1Body,
    col2Heading,
    col2Body,
    col3Heading,
    col3Body
}) => {
    return (
        <div className='module-double-image-and-text theme-light-alt bg-main-background py-24 sm:py-40 md:py-32'>
            <div className='layout-container layout-site-outer-padding'>
                {/* Heading Section */}
                {heading && (
                    <div className='md:mb-32 mb-16'>
                        <h2 className='type-style-2'>
                            {heading}
                        </h2>
                    </div>
                )}

                {/* Images Section */}
                <div className='flex sm:flex-row flex-col gap-16 w-full mb-32'>
                    {image1 && (
                        <div className={`relative overflow-hidden sm:h-[478px] ${image1 && image2 ? 'sm:w-[425px]' : 'w-full'}`}>
                            <SimpleImage
                                {...image1.image}
                                className='w-full h-full object-cover aspect-square'/>
                        </div>
                    )}
                    {image2 && (
                        <div className={`relative overflow-hidden sm:h-[478px] ${image1 && image2 ? 'flex-1' : 'w-full'}`}>
                            <SimpleImage
                                {...image2.image}
                                className='w-full h-full object-cover aspect-square'/>
                        </div>
                    )}
                </div>

                {/* Text Columns Section */}
                <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 col-wrapper gap-y-16'>
                    {/* Column 1 */}
                    {(col1Heading || col1Body) && (
                        <div className='flex flex-col gap-12 col-padding sm:border-r sm:border-main-border'>
                            {col1Heading && (
                                <h3 className='type-style-3'>
                                    {col1Heading}
                                </h3>
                            )}
                            {col1Body && (
                                <p className='type-style-body'>
                                    {col1Body}
                                </p>
                            )}
                        </div>
                    )}

                    {/* Column 2 */}
                    {(col2Heading || col2Body) && (
                        <div className='flex flex-col gap-12 col-padding md:border-r md:border-main-border'>
                            {col2Heading && (
                                <h3 className='type-style-3'>
                                    {col2Heading}
                                </h3>
                            )}
                            {col2Body && (
                                <p className='type-style-body'>
                                    {col2Body}
                                </p>
                            )}
                        </div>
                    )}

                    {/* Column 3 */}
                    {(col3Heading || col3Body) && (
                        <div className='flex flex-col gap-12 col-padding'>
                            {col3Heading && (
                                <h3 className='type-style-3'>
                                    {col3Heading}
                                </h3>
                            )}
                            {col3Body && (
                                <p className='type-style-body'>
                                    {col3Body}
                                </p>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default DoubleImageAndText;
